export default "__VITE_ASSET__nIFjAdmu__";